import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DayPicker } from 'react-day-picker';

import { cn } from '@/utils/tailwind';

import { buttonVariants } from '../PcButton';

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row gap-4',
        month: 'flex flex-col gap-[6px]',

        caption: 'flex justify-center pt-2 relative h-[36px] items-start w-full',
        caption_label: 'Title3S18',

        nav: 'flex items-center gap-2',
        nav_button: cn(
          // buttonVariants({ variant: 'outline' }),
          'w-7 h-7 bg-transparent p-0 opacity-50 hover:opacity-100',
        ),
        nav_button_previous: 'absolute left-[72px] top-[5px]',
        nav_button_next: 'absolute right-[72px] top-[5px]',

        table: 'w-full border-collapse space-x-1',

        //주간
        head_row: 'flex',
        head_cell: 'text-gr-500 rounded-md w-10 Caption1M12',

        row: 'flex w-full mt-2',
        cell: cn(
          'relative p-0 text-center Body5M14  focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-range-end)]:rounded-r-md',
          props.mode === 'range'
            ? '[&:has(>.day-range-end)]:rounded-r-md [&:has(>.day-range-start)]:rounded-l-md first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md'
            : '[&:has([aria-selected])]:rounded-md',
        ),
        day: cn(
          "inline-flex items-center text-gr-800 rounded-full justify-center gap-2 whitespace-nowrap Body5M14 transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='w-'])]:w-4 h-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          'hover:bg-gr-200 hover:text-accent-foreground dark:hover:bg-accent/50',
          'w-[40px] h-[40px] p-0 aria-selected:opacity-100',
        ),
        day_range_start: 'day-range-start aria-selected:bg-point-500 aria-selected:text-white',
        day_range_end: 'day-range-end aria-selected:bg-point-500 aria-selected:text-white',
        day_selected:
          'bg-point-500 text-white hover:bg-point-500 hover:text-white focus:bg-point-500 focus:text-white',
        day_today: 'bg-gr-100 rounded-full text-gr-800',
        day_outside: 'day-outside text-muted-foreground aria-selected:text-muted-foreground',
        day_disabled: 'text-gr-400',
        day_range_middle: 'aria-selected:bg-accent aria-selected:text-accent-foreground',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <ChevronLeft className={cn('h-[24px] w-[24px]', className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <ChevronRight className={cn('h-[24px] w-[24px]', className)} {...props} />
        ),
      }}
      {...props}
    />
  );
}

export { Calendar };
